import { render, staticRenderFns } from "./TaskEditForm.vue?vue&type=template&id=4e9ec3a5"
import script from "./TaskEditForm.vue?vue&type=script&lang=js"
export * from "./TaskEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports